export default () => {
  return [
    {
      label: 'Нэр',
      name: 'name',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
  ]
}